import { decode } from "@mapbox/polyline";
import { GOOGLE_MAPS_API_KEY } from "../constants";

import type { LatLng } from "../types";

export async function getDirections(startLoc: LatLng, destinationLoc: LatLng) {
  try {
    const startLocStr = `${startLoc.lat},${startLoc.lng}`;
    const destinationLocStr = `${destinationLoc.lat},${destinationLoc.lng}`;
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/directions/json?key=${GOOGLE_MAPS_API_KEY}&origin=${startLocStr}&destination=${destinationLocStr}`
    );
    const responseJson = await response.json();
    const points = decode(responseJson.routes[0].overview_polyline.points);
    const coords = points.map((point) => ({ lat: point[0], lng: point[1] }));

    const bounds = responseJson.routes[0].bounds;

    return {
      coords,
      bounds: {
        northEast: { lat: bounds.northeast.lat, lng: bounds.northeast.lng },
        southWest: { lat: bounds.southwest.lat, lng: bounds.southwest.lng },
      },
    };
  } catch (error) {
    throw error;
  }
}

/**
 * Returns a distance between two points in metres
 * ([source](https://www.movable-type.co.uk/scripts/latlong.html))
 */
export function distanceBetween(
  l1: LatLng | undefined,
  l2: LatLng | undefined
) {
  if (!l1 || !l2) {
    return 0;
  }
  const R = 6371e3;
  const φ1 = (l1.lat * Math.PI) / 180; // φ, λ in radians
  const φ2 = (l2.lat * Math.PI) / 180;
  const Δφ = ((l2.lat - l1.lat) * Math.PI) / 180;
  const Δλ = ((l2.lng - l1.lng) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c;

  return d;
}

// export const distanceBetween = (
//   l1: LatLng | undefined,
//   l2: LatLng | undefined
// ) =>
//   !l1 || !l2
//     ? 0
//     : Math.pow(
//         Math.pow(l2?.lat - l1?.lat, 2) + Math.pow(l2?.lng - l1?.lng, 2),
//         0.5
//       );

export const isSameLocation = (
  l1: LatLng | undefined,
  l2: LatLng | undefined
) => distanceBetween(l1, l2) < 50;

// export const isSameLocation = (
//   l1: LatLng | undefined,
//   l2: LatLng | undefined
// ) => l1?.lat === l2?.lat && l1?.lng === l2?.lng;
